import React, { Component } from 'react';
import { Provider } from 'react-redux';
import { Router, Route } from 'react-router-dom'
import { Loader } from 'semantic-ui-react';

import 'semantic-ui-css/semantic.min.css';
import 'react-datepicker/dist/react-datepicker.css';
import './App.css';

import * as paths from './constants'
import history from './history'
import LanguageService from './services/languageService'
import Login from './views/login';
import Dashboard from './views/dashboard';
import PlanView from './views/plan';
import PlanScope from './views/plan_scope/index';
import ResetPassword from './views/password/reset';
import ChangePassword from './views/password/change';
import AdminDashBoard from './views/admin_dashboard';
import AdminView from './views/admin_template';
import Users from './views/users';
import LibraryControls from './views/control_library';
import PlanUploadChannel from './components/plan_upload_channel';
import { getTranslations } from './actions/language'
import { store } from './store';
import { toolTipManager } from './services/instanceService';
import { getInstanceConfig } from './actions/instance';
import { getInstanceConfig as getStoredInstanceConfig } from './helpers/instance_helpers';
import { loadChatbot } from './helpers/chatbot_helpers';

const languageService = new LanguageService()

class App extends Component {
  constructor(props){
    super(props);
    this.state = {
      tooltipsLoaded: false,
    }
  }

  async componentDidMount() {
    const language = 'English';
    getTranslations(language);

    const { features = {} } = await this.loadInstanceConfig();
    await toolTipManager.init(features);
    if (features.ai_chatbot) loadChatbot();
    this.setState({ tooltipsLoaded: true });
  }

// Fetches /instance_config once for the whole app and saves it in the store.
  async loadInstanceConfig() {
    await store.dispatch(getInstanceConfig());
    return getStoredInstanceConfig() || {};
  }

  render() {
    if (!this.state.tooltipsLoaded) {
      return <Loader active inline="centered" size="large">Loading...</Loader>;
    }
    return (
      <Provider store={store}>
        <div className="app">
          <PlanUploadChannel />
          <Router history={history}>
            <div>
              <Route exact path={paths.LOGIN_PATH} component={Login}/>
              <Route exact path={paths.DASHBOARD_PATH + '/:activeItem'} component={Dashboard}/>
              <Route
                exact
                path={paths.LOAD_PLAN_PATH}
                component={(props)=><PlanView {...props} LanguageService={languageService} />}
              />
              <Route exact path={paths.PLAN_ACTIVITIES_PATH} component={PlanScope}/>
              <Route exact path={paths.PASSWORD_RESET_PATH} component={ResetPassword}/>
              <Route exact path={paths.PASSWORD_CHANGE_PATH} component={ChangePassword}/>
              <Route exact path={paths.ADMIN_DASHBOARD_PATH} component={AdminDashBoard}/>
              <Route
                exact
                path={paths.ADMIN_TEMPLATE_PATH}
                component={(props)=><AdminView  {...props} LanguageService={languageService} />}
              />
              <Route exact path={paths.USERS_PATH} component={Users}/>
              <Route exact path={paths.LIBRARY_CONTROLS_PATH} component={LibraryControls}/>
            </div>
          </Router>
        </div>
      </Provider>

    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js